import { Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { LabeledValue } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';

export const PartAliasCell = (props: ICellRendererParams) => {
  const data = getAgGridTableCellData(props, 'alias');
  if (!data) {
    return props?.value;
  }

  const { partEngineeringNumber, partOrderingNumber } = data;

  if (!partEngineeringNumber && !partOrderingNumber) {
    return DEFAULT_PLACEHOLDER;
  }

  return (
    <Stack justifyContent={'flex-end'}>
      <LabeledValue label={t('labelPartOrderingNumber')} value={partOrderingNumber} />
      <LabeledValue label={t('labelPartEngineeringNumber')} value={partEngineeringNumber} />
    </Stack>
  );
};
